/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_StartedInputs */

const en_follow_started = /** @type {(inputs: Follow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following: each change of its status reaches your notifications.`)
};

/**
* | output |
* | --- |
* | "Following: each change of its status reaches your notifications." |
*
* @param {Follow_StartedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_started = /** @type {((inputs?: Follow_StartedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_StartedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_started(inputs)
});